var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8901 2.85976L9.6402 0.60983C9.53295 0.502584 9.37171 0.470335 9.23146 0.528833C9.09122 0.587331 8.99972 0.723077 8.99972 0.874572V1.99954H4.12487C1.84644 1.99954 0 3.84598 0 6.12441C0 6.3314 0.167995 6.4994 0.374988 6.4994H1.87494C2.08194 6.4994 2.24993 6.3314 2.24993 6.12441C2.24993 5.08869 3.08915 4.24947 4.12487 4.24947H8.99972V5.37443C8.99972 5.52593 9.09122 5.66317 9.23146 5.72092C9.37171 5.77942 9.53295 5.74717 9.6402 5.63992L11.8901 3.38999C12.0364 3.24375 12.0364 3.00601 11.8901 2.85976Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6248 6.49902H10.1249C9.91788 6.49902 9.74988 6.66702 9.74988 6.87401C9.74988 7.90973 8.91066 8.74896 7.87494 8.74896H3.00009V7.62399C3.00009 7.4725 2.9086 7.33525 2.76835 7.2775C2.62811 7.21975 2.46761 7.252 2.35961 7.35925L0.109684 9.60918C-0.0365614 9.75543 -0.0365614 9.99317 0.109684 10.1394L2.35961 12.3894C2.46686 12.4966 2.62811 12.5288 2.76835 12.4704C2.9086 12.4119 3.00009 12.2754 3.00009 12.1239V10.9989H7.87494C10.1534 10.9989 11.9998 9.15245 11.9998 6.87401C11.9998 6.66702 11.8318 6.49902 11.6248 6.49902Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/Repeat.42d6c8bf.svg";
export { ForwardRef as ReactComponent };